import {
  createFileRoute,
  redirect,
  Outlet,
  useParams,
  useNavigate,
} from '@tanstack/react-router';
import { Box, CircularProgress } from '@mui/material';
import { useEffect } from 'react';

import { useOptimisticUpdates } from '@hooks';
import { useAuthStore } from '@core/features/auth';
import { NavigationBar } from '@components';
import { useGetVenue } from '@customer/features/venues';

const LayoutComponent = () => {
  const { venueSlug } = useParams({ from: '/$venueSlug' });
  const { data: venue, isPending, isError } = useGetVenue(venueSlug);
  const navigate = useNavigate();

  useOptimisticUpdates();

  useEffect(() => {
    // Only redirect after query is done and venue doesn't exist
    if (!isPending && (isError || !venue)) {
      navigate({ to: '/' });
    }
  }, [isPending, isError, venue, navigate]);

  // Wait for the query to finish before deciding
  if (isPending) {
    return <CircularProgress />;
  }

  // If venue doesn't exist, show nothing while redirect happens
  if (isError || !venue) {
    return null;
  }

  return (
    <>
      <NavigationBar />
      <Box sx={{ height: '100%', paddingTop: 20 }}>
        <Outlet />
      </Box>
    </>
  );
};

export const Route = createFileRoute('/$venueSlug')({
  beforeLoad: async ({ params }) => {
    const accessToken = useAuthStore.getState().accessToken;

    if (!accessToken) {
      throw redirect({
        to: '/auth/$venueSlug',
        params: { venueSlug: params.venueSlug },
      });
    }
  },
  component: LayoutComponent,
});
